import { axiosClient } from "services/axios";

import { ApplyImageLinkToProductParams } from "../types";

export function getMeasureUnits() {
  return axiosClient.get("documents/measureunits").then((res) => res.data);
}

export function getNDS() {
  return axiosClient.get("documents/nds").then((res) => res.data);
}

export function addProduct(params: any) {
  return axiosClient.post("items/", params);
}

export function editProduct(params: any) {
  return axiosClient.put("items/item", params);
}

export function uploadProductImage(image: any) {
  return axiosClient.post(
    "items/upload-image",
    { file: image },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

export function applyImageLinkToProduct(params: ApplyImageLinkToProductParams) {
  return axiosClient.post("items/image", params, {});
}

export function getProductImage(itemid: string) {
  return axiosClient
    .get("items/image", {
      params: { itemid },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}
